<div *ngIf="showFullScreenAd$ | async">
  <app-full-screen-ad></app-full-screen-ad>
</div>

<router-outlet></router-outlet>
